import Global from '../../store/global-selectors';
import { FulfillmentPlanFulfillmentType } from '../../enums/fulfillment-plan-fulfillment-type';

type FulfillmentPlanWithFulfillmentType = { fulfillmentType?: string };

export const hasFreightInBulkSelection = (state: unknown, fulfillmentPlanIds: readonly string[]): boolean => {
  if (fulfillmentPlanIds.length === 0) {
    return false;
  }

  return Global.selectEntitiesFulfillmentPlansByIds(state, { fulfillmentPlanIds }).some(
    (fulfillmentPlan: FulfillmentPlanWithFulfillmentType) => fulfillmentPlan?.fulfillmentType === FulfillmentPlanFulfillmentType.FreightLtl,
  );
};
